module.exports = __webpack_public_path__ + "img/Graduated.49c1ea7d.svg";